
<button *ngIf="status != 'wip' && q && qs.bldrSet " class= "mx-2  btn-sm-3 btn-primary"   (click)="qs.postTag(qs.bldrSet,q.id,i); showAddI= i;">Add to Set: {{qs.bldrSet}}</button>


 <div class= 'btn-danger' *ngIf="filterQstn">already in bstr-set </div>  
